import { IOrderProductDeclineForm } from '../../../../data-handlers/order/IOrderDataHandler'
import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestProductDecline {
  type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE;
  payload: {
    product: OrderProduct
    declineData: IOrderProductDeclineForm
  }
}

export function requestProductDecline({
  product,
  declineData,
}: RequestProductDecline['payload']): RequestProductDecline {
  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE,
    payload: {
      product,
      declineData,
    },
  }
}

export interface RequestProductDeclineSuccess {
  type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE_SUCCESS;
  payload: {
    product: OrderProduct
  }
}

export function requestProductDeclineSuccess({
  product,
}: RequestProductDeclineSuccess['payload']): RequestProductDeclineSuccess {

  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE_SUCCESS,
    payload: {
      product,
    },
  }
}

export interface RequestProductDeclineFailure {
  type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE_FAILURE;
  payload: {
    product:  OrderProduct
    error:    ApiError;
  }
}

export function requestProductDeclineFailure({
  product,
 error,
}: RequestProductDeclineFailure['payload']): RequestProductDeclineFailure {

  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_DECLINE_FAILURE,
    payload: {
      product,
      error,
    },
  }
}
